export class Cargo {
  public cargo?: string;
  public description?: string;
  public descriptionEn?: string;
  public descriptionDe?: string;
}
